import React, { useState } from 'react';
import ProjectSingle from '../ProjectSingle/ProjectSingle';
import { Link } from 'react-scroll';
import { getMobileProjects, getWebProjects } from '../../api/project';
import './ProjectSectionS3.css';

const ProjectSectionS3 = (props) => {
    const [open, setOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);

    // Proje verilerini import et
    const mobileProjects = getMobileProjects();
    const webProjects = getWebProjects();

    const handleClose = () => {
        setOpen(false);
        setSelectedProject(null);
    };

    const handleProjectClick = (project) => {
        setOpen(true);
        setSelectedProject(project);
    };

    // GitHub linkine yönlendiren fonksiyon
    const handleGithubRedirect = (githubLink, e) => {
        if (e) {
            e.stopPropagation();
        }
        if (githubLink) {
            window.open(githubLink, '_blank', 'noopener,noreferrer');
        }
    };

    // Canlı demo/Play Store linkine yönlendiren fonksiyon
    const handleExternalLink = (link, e) => {
        if (e) {
            e.stopPropagation();
        }
        if (link) {
            window.open(link, '_blank', 'noopener,noreferrer');
        }
    };

    // Tüm kartı tıklayınca GitHub'a yönlendir
    const handleCardClick = (project) => {
        // Öncelikle GitHub linkine yönlendir, yoksa canlı linke
        if (project.githubLink) {
            handleGithubRedirect(project.githubLink);
        } else if (project.liveLink) {
            handleExternalLink(project.liveLink);
        } else if (project.playStoreLink) {
            handleExternalLink(project.playStoreLink);
        }
    };

    return (
        <section className="projects-section" id="projects">
            <div className="row projects-container">
                {/* Sol Kolon - Mobil Projeler */}
                <div className="col-lg-6 mb-5 mb-lg-0">
                    <div className="projects-column mobile-projects">
                        <div className="column-header">
                            <div className="column-icon">
                                <i className="fas fa-mobile-alt"></i>
                            </div>
                            <h3 className="column-title">Mobil Projelerim</h3>
                        </div>

                        <div className="projects-grid">
                            {mobileProjects.map((project) => (
                                <div
                                    className="project-card mobile-project-card"
                                    key={project.id}
                                    onClick={() => handleCardClick(project)}
                                >
                                    <div className="project-image-wrapper">
                                        <div className="project-image-container mobile-image">
                                            <img
                                                src={project.image}
                                                alt={project.title}
                                                className="project-image"
                                                loading="lazy"
                                            />
                                            <div className="project-overlay">
                                                <span className="view-details">
                                                    <i className="fab fa-github me-2"></i>
                                                    GitHub'da Gör
                                                </span>
                                            </div>
                                        </div>
                                        <div className="project-badge mobile-badge">
                                            <i className="fab fa-google-play me-1"></i>
                                            Mobil
                                        </div>
                                    </div>

                                    <div className="project-content">
                                        <h4 className="project-title">{project.title}</h4>
                                        <p className="project-description">{project.description}</p>

                                        <div className="project-technologies">
                                            {project.technologies.map((tech, index) => (
                                                <span key={index} className="tech-badge">{tech}</span>
                                            ))}
                                        </div>

                                        <div className="project-footer">
                                            <div className="project-links">
                                                {project.githubLink && (
                                                    <a
                                                        href={project.githubLink}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="project-link github-link"
                                                        onClick={(e) => handleGithubRedirect(project.githubLink, e)}
                                                    >
                                                        <i className="fab fa-github"></i>
                                                        <span>GitHub</span>
                                                    </a>
                                                )}
                                                {project.playStoreLink && (
                                                    <a
                                                        href={project.playStoreLink}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="project-link playstore-link"
                                                        onClick={(e) => handleExternalLink(project.playStoreLink, e)}
                                                    >
                                                        <i className="fab fa-google-play"></i>
                                                        <span>Play Store</span>
                                                    </a>
                                                )}
                                                {!project.githubLink && !project.playStoreLink && (
                                                    <a
                                                        href="#"
                                                        className="project-link disabled-link"
                                                        onClick={(e) => e.preventDefault()}
                                                    >
                                                        <i className="fas fa-lock"></i>
                                                        <span>Private</span>
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Sağ Kolon - Web Projeler */}
                <div className="col-lg-6">
                    <div className="projects-column web-projects">
                        <div className="column-header">
                            <div className="column-icon">
                                <i className="fas fa-desktop"></i>
                            </div>
                            <h3 className="column-title">Web Projelerim</h3>
                        </div>

                        <div className="projects-grid">
                            {webProjects.map((project) => (
                                <div
                                    className="project-card web-project-card"
                                    key={project.id}
                                    onClick={() => handleCardClick(project)}
                                >
                                    <div className="project-image-wrapper">
                                        <div className="project-image-container web-image">
                                            <img
                                                src={project.image}
                                                alt={project.title}
                                                className="project-image"
                                                loading="lazy"
                                            />
                                            <div className="project-overlay">
                                                <span className="view-details">
                                                    {project.githubLink ? (
                                                        <>
                                                            <i className="fab fa-github me-2"></i>
                                                            GitHub'da Gör
                                                        </>
                                                    ) : project.liveLink ? (
                                                        <>
                                                            <i className="fas fa-external-link-alt me-2"></i>
                                                            Canlı Demo
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fas fa-search-plus me-2"></i>
                                                            Detayları Gör
                                                        </>
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="project-badge web-badge">
                                            <i className="fas fa-globe me-1"></i>
                                            Web
                                        </div>
                                    </div>

                                    <div className="project-content">
                                        <h4 className="project-title">{project.title}</h4>
                                        <p className="project-description">{project.description}</p>

                                        <div className="project-technologies">
                                            {project.technologies.map((tech, index) => (
                                                <span key={index} className="tech-badge">{tech}</span>
                                            ))}
                                        </div>

                                        <div className="project-footer">
                                            <div className="project-links">
                                                {project.githubLink && (
                                                    <a
                                                        href={project.githubLink}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="project-link github-link"
                                                        onClick={(e) => handleGithubRedirect(project.githubLink, e)}
                                                    >
                                                        <i className="fab fa-github"></i>
                                                        <span>GitHub</span>
                                                    </a>
                                                )}
                                                {project.liveLink && (
                                                    <a
                                                        href={project.liveLink}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="project-link live-link"
                                                        onClick={(e) => handleExternalLink(project.liveLink, e)}
                                                    >
                                                        <i className="fas fa-external-link-alt"></i>
                                                        <span>Canlı Demo</span>
                                                    </a>
                                                )}
                                                {!project.githubLink && !project.liveLink && (
                                                    <a
                                                        href="#"
                                                        className="project-link disabled-link"
                                                        onClick={(e) => e.preventDefault()}
                                                    >
                                                        <i className="fas fa-lock"></i>
                                                        <span>Private</span>
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProjectSectionS3;